<template>
	<svg :width="width" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 3.66917C0 2.69605 0.386309 1.76278 1.07394 1.07468C1.76158 0.386572 2.69421 0 3.66667 0H18.3333C19.3058 0 20.2384 0.386572 20.9261 1.07468C21.6137 1.76278 22 2.69605 22 3.66917V13.4536C22 14.4268 21.6137 15.36 20.9261 16.0481C20.2384 16.7362 19.3058 17.1228 18.3333 17.1228H13.9504L16.753 19.9273C16.9756 20.1579 17.0988 20.4669 17.096 20.7876C17.0933 21.1083 16.9647 21.415 16.7381 21.6418C16.5115 21.8685 16.205 21.9972 15.8845 22C15.564 22.0027 15.2553 21.8795 15.0248 21.6567L11 17.6291L6.97522 21.6567C6.74471 21.8795 6.43597 22.0027 6.11551 22C5.79505 21.9972 5.4885 21.8685 5.26189 21.6418C5.03528 21.415 4.90674 21.1083 4.90395 20.7876C4.90117 20.4669 5.02436 20.1579 5.247 19.9273L8.04956 17.1228H3.66667C2.69421 17.1228 1.76158 16.7362 1.07394 16.0481C0.386309 15.36 0 14.4268 0 13.4536V3.66917ZM17.1111 6.11529C17.1111 5.79091 16.9823 5.47982 16.7531 5.25045C16.5239 5.02109 16.213 4.89223 15.8889 4.89223C15.5647 4.89223 15.2539 5.02109 15.0246 5.25045C14.7954 5.47982 14.6667 5.79091 14.6667 6.11529V11.0075C14.6667 11.3319 14.7954 11.643 15.0246 11.8723C15.2539 12.1017 15.5647 12.2306 15.8889 12.2306C16.213 12.2306 16.5239 12.1017 16.7531 11.8723C16.9823 11.643 17.1111 11.3319 17.1111 11.0075V6.11529ZM12.2222 8.5614C12.2222 8.23703 12.0935 7.92594 11.8642 7.69657C11.635 7.4672 11.3242 7.33834 11 7.33834C10.6758 7.33834 10.365 7.4672 10.1358 7.69657C9.90655 7.92594 9.77778 8.23703 9.77778 8.5614V11.0075C9.77778 11.3319 9.90655 11.643 10.1358 11.8723C10.365 12.1017 10.6758 12.2306 11 12.2306C11.3242 12.2306 11.635 12.1017 11.8642 11.8723C12.0935 11.643 12.2222 11.3319 12.2222 11.0075V8.5614ZM7.33333 9.78446C7.33333 9.46008 7.20456 9.14899 6.97535 8.91963C6.74614 8.69026 6.43526 8.5614 6.11111 8.5614C5.78696 8.5614 5.47608 8.69026 5.24687 8.91963C5.01766 9.14899 4.88889 9.46008 4.88889 9.78446V11.0075C4.88889 11.3319 5.01766 11.643 5.24687 11.8723C5.47608 12.1017 5.78696 12.2306 6.11111 12.2306C6.43526 12.2306 6.74614 12.1017 6.97535 11.8723C7.20456 11.643 7.33333 11.3319 7.33333 11.0075V9.78446Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: 'WebIcon',
	props: {
		color: {
			type: String,
			default: ''
		},
		width: {
			type: Number,
			default: 25
		},
		height: {
			type: Number,
			default: 30
		}
	}
}
</script>
